// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
// Shared imports
const {
  TYPES: modelTypes,
  ARTICLE_SUBTYPES: articleSubtypes
} = require('shared/model-types')
// Common Client V2 imports
const { keyedReviver } = require('client-v2/common/state/record-reviver')
// Sibling imports
const { ARTICLE_IS_MIXED_CHANGE_PENDING } = require('./actions')

class ArticleModelRecord extends Immutable.Record({
  count: Number(),
  description: String(),
  embedUrl: String(),
  hash: String(),
  hostname: String(),
  image: String(),
  isCurated: Boolean(),
  isMixed: Boolean(),
  isUnmixable: Boolean(),
  md5image: String(),
  'mixes_count': Number(),
  'mixers_count': Number(),
  subtype: String(articleSubtypes.TEXT_WITH_IMAGE),
  title: String(),
  type: String(modelTypes.ARTICLE),
  url: String(),
  'url_id': String()
}) {
  // No methods
}

ArticleModelRecord.reviver = keyedReviver(ArticleModelRecord, {
  // No nested data structures
})

ArticleModelRecord.propTypes = {
  count: PropTypes.number,
  description: PropTypes.string,
  embedUrl: PropTypes.string,
  hash: PropTypes.string,
  hostname: PropTypes.string,
  image: PropTypes.string,
  isCurated: PropTypes.bool,
  isMixed: PropTypes.oneOf([
    true,
    false,
    ARTICLE_IS_MIXED_CHANGE_PENDING
  ]),
  isUnmixable: PropTypes.bool,
  md5image: PropTypes.string,
  'mixes_count': PropTypes.number,
  'mixers_count': PropTypes.number,
  subtype: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
  'url_id': PropTypes.string
}

module.exports = ArticleModelRecord
